import React, { useRef, useState } from "react";
import {
    Button,
    FormControl,
    FormHelperText,
    IconButton,
    InputAdornment,
    InputLabel,
    OutlinedInput,
    Typography,
} from "@mui/material";
import LoginWrapper from "../../components/LoginWrapper";
import { useLocation, useNavigate } from "react-router-dom";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { bannerJson } from "utils/dummy";
import i18n from "i18n/i18n";
import { useBoundStore } from "store/store";

function NewPassword() {

  let lang = navigator?.language.split("-")[0]; // e.g "de" from de-DE 


    const navigate = useNavigate();

    const [showPassword, setShowPassword] = React.useState(false);

    const passwordRef = useRef<HTMLInputElement>(null);

    const [loginPassword, setLoginPassword] = useState("");

    const [validationError, setValidationError] = useState(false);
    const [validationErrorMessage, setValidationErrorMessage] = useState("");

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (
        event: React.MouseEvent<HTMLButtonElement>
    ) => {
        event.preventDefault();
    };

    const handlePasswordChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        let value = e.target.value;
        setLoginPassword(value);

        const reg = new RegExp("(?=[A-Za-z0-9@#$%^&+!=]+$)^(?=.*[a-z])(?=.*[A-Z])(?=.{8,}).*$");  // min 8 characters , one uppercase and one lowercase is must
        if (reg.test(value)) {
          setValidationError(false);
          setValidationErrorMessage("");
        }
        else {
          setValidationError(true);
          setValidationErrorMessage(i18n(lang)?.password_validation_error);
        }
    };



    const submitForm = () => {
        if (loginPassword === "") {
            passwordRef.current?.focus();
            return;
        }
        navigate("/login?status=0")
    };

    const { search } = useLocation();
    let query = new URLSearchParams(search);

    return (
        <LoginWrapper showLogo={true} showBanner={query.get("status")} bannerContent={bannerJson[Number(query.get("status"))]}>
            <div className="content">
                <Typography variant="h6" textAlign={"center"}>
                    {i18n(lang)?.new_password_title}
                </Typography>

                <Typography variant="subtitle2" textAlign={"center"} sx={{ marginTop: 1 }}>
                    {i18n(lang)?.new_password_detail}
                </Typography>
                <div className="form">
                    <FormControl
                        sx={{ width: "25ch" }}
                        variant="outlined"
                        className="inputField"
                    >
                        <InputLabel htmlFor="outlined-adornment-password">
                            {i18n(lang)?.password}
                        </InputLabel>
                        <OutlinedInput
                            id="outlined-adornment-password"
                            type={showPassword ? "text" : "password"}
                            error={validationError}
                            inputRef={passwordRef}
                            onChange={handlePasswordChange}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label="toggle password visibility"
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label={i18n(lang)?.password}
                        />
                      {validationError ? <FormHelperText error id="accountId-error">{validationErrorMessage}</FormHelperText> : ""}
                    </FormControl>

                    <Button
                        fullWidth
                        variant="contained"
                        className="lp125" 
                        sx={{ marginTop: 3,backgroundColor:"var(--primary-color)",letterSpacing:1.25 }}
                        disabled={validationError || loginPassword === ""}
                        onClick={submitForm}
                    >
                        {i18n(lang)?.assign_new_password}
                    </Button>

                </div>
            </div>
        </LoginWrapper>
    );
}

export default NewPassword;
